class SupportService {
  constructor($window, analyticsService) {
    this._$window = $window;
    this._analyticsService = analyticsService;

    this.ready = false;
    this.api = null;

    this.onReady(() => {
      this.api = this._$window.drift.api;
    });
  }

  show() {
    if (this.api) {
      this.api.widget.show();
    }
  }

  hide() {
    if (this.api) {
      this.api.widget.hide();
    }
  }

  showNewMessage(message) {
    if (this.api) {
      this.api.showWelcomeMessage({
        showAvatar: true,
        slide: false,
        message: message
      });
    }
  }

  onReady(callback) { //eslint-disable-line
    if (this.ready) return callback();

    this._analyticsService.onReady(() => {
      if (this._$window.drift) {
        this._$window.drift.on('ready', () => {
          this.ready = true;
          callback();
        });
      }
    });
  }

}

SupportService.$inject = [
  '$window',
  'analyticsService'
];

export default SupportService;



// WEBPACK FOOTER //
// ./src/services/supportService.js